module.exports = __webpack_public_path__ + "static/media/Flaticon2.29586ff0.eot";